import { type TFunction } from "i18next"

export const searchfieldTemplate = (t: TFunction, categories: string) => `
<div class="addsearch-searchfield-container">
  <form class="addsearch-searchfield" autocomplete="off" action="?" role="search">
    <div class="search-field-wrapper w-full relative h-12 flex justify-between rounded bg-white-5 border-1 hover:border-ink-50 hover:focus-within:border-primary focus-within:border-primary focus-within:outline focus-within:outline-2 focus-within:outline-aqua-200">
      <input id="search-input" type="text" data-gtm="site-search" class="w-full h-full px-4 py-3 bg-white-5 border-0 hover:!border-0 hover:focus:border-0 focus:bg-white focus:!shadow-none focus:!border-0" placeholder="${t(
        "menu.search_placeholder"
      )}" aria-label="Search field" data-categories="${categories}"/>
      <span class="flex items-center icon-container rounded-r">
        <span class="close-icon mx-3 m-auto cursor-pointer">
          <span class="hidden">
            <svg class="block" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6.707 18.707a1 1 0 01-1.414-1.414L10.586 12 5.293 6.707a1 1 0 011.414-1.414L12 10.586l5.293-5.293a1 1 0 111.414 1.414L13.414 12l5.293 5.293a1 1 0 01-1.414 1.414L12 13.414z" fill="currentColor"/></svg>
          </span>
        </span>
        <span class="h-6 m-auto border-l-1 border-white-20 block"></span>
        <span class="left-icon px-3 m-auto cursor-pointer items-center flex">
          <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="M11 3a8 8 0 104.906 14.32l3.387 3.387a1 1 0 001.414-1.414l-3.387-3.387A8 8 0 0011 3zm-6 8a6 6 0 1112 0 6 6 0 01-12 0z" fill="currentColor" fill-rule="evenodd"/></svg>
        </span>
      </span>
    </div>
  </form>
</div>
 `

export const searchresultsTemplate = () => `
  <div class="addsearch-searchresults results bg-white">
    {{#each hits}}
      <div class="hit{{#equals type "PROMOTED"}} promoted{{/equals}} p-3 hover:bg-white-5">
        <a href="{{url}}" class="flex" data-analytics-click="{{id}}" data-title="{{title}}">
          <div class="header pr-3 flex items-center">
            {{> searchResultImageTemplate}}
          </div>
          <div class="flex flex-col w-full">
            <p class="heading-five">{{title}}</p>
            <p class="paragraph-xs mb-0 highlight text-ink-85">{{{highlight}}}...</p>
          </div>
        </a>
      </div>
      <div class="border-b border-white-10 mx-3"></div>
    {{/each}}
  </div>
`

export const noResultsTemplate = (t: TFunction) => `
<div class="addsearch-searchresults addsearch-searchresults-no-results w-full sm:w-auto bg-white px-3 py-6 flex flex-col items-center">
  <span class="justify-center w-10 h-10 bg-red-100 flex items-center border border-white-10 mb-2">
    <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor"><path d="M12 17a1 1 0 110-2 1 1 0 010 2zM12 14a1 1 0 01-1-1V8a1 1 0 112 0v5a1 1 0 01-1 1z"/><path clip-rule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-2a8 8 0 100-16 8 8 0 000 16z" fill-rule="evenodd"/></g></svg>
  </span>
  <h4 class="center mb-1">${t("help_center.no_results")}</h4>
  <p class="paragraph-xs center mb-0">
    ${t("help_center.broader_term")}<a href='${t("route.contact")}'>${t("help_center.contact_us")}</a>.
  </p>
</div>
<div class="h-auto rounded-b-lg flex items-center w-full relative border-t-1 border-white-10 px-3 py-2 sm:px-4 bg-white">
  <p class="paragraph mb-0 mr-3 text-sm sm:text-base">${t("examples.cta_header")}</p>
  <a href='${t(
    "route.quote"
  )}' class="button button-primary button-large sm:button-medium mb-0" data-gtm="search-result-quote">
    ${t("menu.request_quote")}
  </a>
</div>
`

export const infiniteScrollTemplate = (t: TFunction) => `
  {{#if totalHits}}
    <div class="h-16 sm:h-14 rounded-b-lg flex items-center -ml-4 relative w-[calc(100%_+_32px)] sm:w-auto sm:ml-0 shadow-lg border border-white-10 border-t-0 px-3 py-2 sm:px-4 bg-white">
      <p class="paragraph mb-0 mr-3 text-sm sm:text-base">${t("examples.cta_header")}</p>
      <a href='${t(
        "route.quote"
      )}' class="button button-primary button-large sm:button-medium mb-0" data-gtm="search-result-quote">
        ${t("menu.request_quote")}
      </a>
    </div>
  {{/if}}
  <div class="addsearch-loadmore">
    {{#if isLoading}}
      <div class="flex justify-center items-center -ml-4 relative rounded-lg w-[calc(100%_+_32px)] sm:w-auto sm:ml-0 bg-white h-6 shadow-lg border border-white-10 border-t-0">
        <div class="h-[6px] w-[30px]"><span class="flex justify-between "><i class="block rounded-full w-[6px] h-[6px] animate-blink-fast bg-slate-400" style="animation-delay: -0.2s;"></i><i class="block rounded-full w-[6px] h-[6px] animate-blink-fast bg-slate-400" style="animation-delay: -0.1s;"></i><i class="block rounded-full w-[6px] h-[6px] animate-blink-fast bg-slate-400"></i></span></div>
      </div>
    {{else if hasMorePages}}
      {{#equals type "INFINITE_SCROLL"}}
        <span class="loadmore-infinite-scroll"></span>
      {{/equals}}
    {{/if}}
  </div>
`
